"use client";

import { Input } from "../ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { FormField } from "../ui/form-field";
import { getServiceCity } from "redux/actions/UserServiceCity";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

export default function AddTollForm({
  formData,
  onFormDataChange,
  vehicleTypes,
  fuelType,
  locations,
}) {
  const dispatch = useDispatch();
  const cityData = useSelector(
    (state) => state?.userServiceCity?.userServiceCity?.data
  );
  const cityOptions =
    cityData?.length > 0
      ? cityData.map((val) => ({ name: val?.name, id: val?.id }))
      : [];

  const updateFormData = (field, value) => {
    onFormDataChange({ ...formData, [field]: value });
  };

  useEffect(() => {
    dispatch(getServiceCity());
  }, [dispatch]);

  // Set Bengaluru as default city if not already set
  // useEffect(() => {
  //   if (!formData.location && cityOptions.length > 0) {
  //     const bengaluru = cityOptions.find(
  //       (city) => city.name.toLowerCase() === "bengaluru"
  //     );
  //     if (bengaluru) {
  //       updateFormData("location", bengaluru.id);
  //     }
  //   }
  //   // eslint-disable-next-line
  // }, [cityOptions]);

  return (
    <>
      <FormField label="Toll Name" required htmlFor="toll">
        <Input
          id="toll"
          placeholder="Enter toll name"
          value={formData.toll}
          onChange={(e) => updateFormData("toll", e.target.value)}
          className="h-12 text-base bg-white"
        />
      </FormField>

      <FormField label="Vehicle Type" required>
        <Select
          value={formData.vehicleType}
          onValueChange={(value) => updateFormData("vehicleType", value)}
        >
          <SelectTrigger className="h-12 text-base bg-white border border-gray-300">
            <SelectValue placeholder="Choose vehicle type" />
          </SelectTrigger>
          <SelectContent className="bg-white border border-gray-200 shadow-lg z-50">
            {vehicleTypes.map((type) => (
              <SelectItem
                key={type.value}
                value={type.value}
                className="text-base bg-white hover:bg-gray-50 focus:bg-gray-50 cursor-pointer"
              >
                {type.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </FormField>

      <FormField label="Fuel Type" required>
        <Select
          value={formData.fuelType}
          onValueChange={(value) => updateFormData("fuelType", value)}
        >
          <SelectTrigger className="h-12 text-base bg-white border border-gray-300">
            <SelectValue placeholder="Choose vehicle type" />
          </SelectTrigger>
          <SelectContent className="bg-white border border-gray-200 shadow-lg z-50">
            {fuelType.map((type) => (
              <SelectItem
                key={type.value}
                value={type.value}
                className="text-base bg-white hover:bg-gray-50 focus:bg-gray-50 cursor-pointer"
              >
                {type.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </FormField>

      <FormField label="Location" required>
        <Select
          value={formData.location}
          onValueChange={(value) => updateFormData("location", value)}
        >
          <SelectTrigger className="h-12 text-base bg-white border border-gray-300">
            <SelectValue placeholder="Choose location" />
          </SelectTrigger>
          <SelectContent className="bg-white border border-gray-200 shadow-lg z-50">
            {cityOptions.map((location) => (
              <SelectItem
                key={location?.id}
                value={location?.id}
                className="text-base bg-white hover:bg-gray-50 focus:bg-gray-50 cursor-pointer"
              >
                {location?.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </FormField>

       <FormField label="Charges" required htmlFor="charges">
        <Input
          id="charges"
          type="number"
          placeholder="Enter charges"
          value={formData.charges}
          onChange={(e) => updateFormData("charges", e.target.value)}
          className="h-12 text-base bg-white"
          onWheel={(e) => e.target.blur()}
        />
      </FormField>

    </>
  );
}
